import React from "react";

const Metrics = ({ title, value, meta, className }) => {
    return (
        <div className={`bg-white !border !border-[#F4F0FF] rounded-lg !p-4 ${className}`}>
            <p className="text-sm font-medium text-main-grey">{title}</p>
            <h3 className="text-[32px] font-normal !mt-[11px] !mb-2 !text-main">{value}</h3>
            {meta}
        </div>
    );
};

export default Metrics;
